export const groupParties = (party, year) => {
    // convert into grouped names
    if (year <= 1919) {
        switch (party) {
            case 'Australian Labor Party':
            case 'ALP':
                return 'Australian Labor Party'
            case 'Nationalist':
            case 'Nat':
                return 'Nationalist';
            case 'Liberal (1910-14)':
            case 'Lib10':
            case 'Lib':
                return 'Liberal (1910-14)';
            case 'Anti-Socialist':
            case 'AS':
                return 'Anti-Socialist';
            case 'Protectionist':
            case 'Prot':
                return 'Protectionist';
            case 'Free Trade':
            case 'FT':
                return 'Free Trade';
            case 'Ind FT':
                return 'Independent Free Trade';
            case 'Ind':
                return 'Independent';
            default:
                return party ? party : 'Independent';
        }
    }
    switch (party) {
        case 'Liberal Party of Australia':
        case 'Nationals':
        case 'The Nationals':
        case 'Liberal National Party of Queensland':
        case 'Country Liberals (NT)':
        case 'Country Liberal':
        case 'Northern Territory Country Liberal Party':
        case 'Liberal Party (W.A. Division) Inc.':
        case 'National Party of Australia - N.S.W.':
        case 'National Party of Australia - Victoria':
        case 'National Party of Australia (Queensland)':
        case 'Lib':
        case 'Lib46':
        case 'CP':
        case 'National Country':
        case 'NCP':
        case 'NT CLP':
        case 'Country': // country coalition?
        case 'National Alliance':
        case 'United Australia':
        case 'United Country (1934-43)':
        case 'Liberal Country':
        case 'UAP':
        case 'UAP31':
        case 'Australian Country':
        case 'Nationalist':
        case 'Nat':
            return coalitionName(year); 
        case 'Liberal (1922)':
        case 'Lib22':
            return 'Liberal (1922)';
        case 'The Greens':
        case 'The Greens (WA)':
        case 'Queensland Greens':
        case 'The Greens (VIC)':
        case 'Australian Greens':
            return 'The Greens'
        case 'Australian Labor Party':
        case 'Australian Labor Party (Northern Territory) Branch':
        case 'A.L.P.':
        case 'Labor':
        case 'ALP':
            return 'Australian Labor Party'
        case 'Ind UAP31':
            return 'Independent';        
        default:
            return party ? party : 'Independent';
    }
}
const coalitionName = year => {
    if (year <= 1929) {
        return 'Nationalist / Country Coalition';
    }
    else if (year <= 1943) {
        return  'Country / UAP Coalition'
    } else {
        return 'Liberal / National Coalition'
    }
}